const shippingStatusReasonsModel = vm => ({
  title: vm.$gettext('Shipping Status Reasons'),
  endpoint: 'shipping-status-reasons',
  allowNew: true,
  shared: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'event',
      label: vm.$gettext('Event'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Must be one of: "CONFIRMED", "PICKEDUP", "INTRANSIT", "DELIVERED"')
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: false,
      editable: true
    }
  ],
  filters: ['id', 'event', 'name', 'description']
})

export default shippingStatusReasonsModel
